"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildClickHelpTopicURL = buildClickHelpTopicURL;
function buildClickHelpTopicURL(opts) {
  var id = opts.id,
    _opts$baseURL = opts.baseURL,
    baseURL = _opts$baseURL === void 0 ? 'https://docs.tackle.io' : _opts$baseURL,
    _opts$isApiUrl = opts.isApiUrl,
    isApiUrl = _opts$isApiUrl === void 0 ? true : _opts$isApiUrl;
  var apiPath = "/api/v1/projects/tackle-docs/articles/".concat(id);
  var articlePath = "/articles/#!tackle-docs/".concat(id);
  var path = isApiUrl ? apiPath : articlePath;
  var topicURL = "".concat(baseURL).concat(path);
  return topicURL;
}